import React, { Component } from 'react';
import './login.style.css';
// import { Container, Content, button, Text, Form, Item, input, label } from 'native-base';
import UserContext from '../../utils/userContext';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas);

export default class Login extends Component {
	static contextType = UserContext
	constructor(props) {
		super(props);
		this.state = {
			validating: false,
			caution: ""
		}
	}
	render() {
		return (
			<div className="login-modal-wrap">
				<div className="login-data">
					<div className="login-header">เข้าสู่ระบบ</div>
					<div className="login-subhead">เพื่อประสบการณ์การใช้งานแบบไร้ขีดจำกัด</div>
					<form>
						<div className="login-input-wrap">

							<label className="login-lb">อีเมล</label>
							<div className="login-input">
								<FontAwesomeIcon style={{ fontSize: "20px", color: "grey", marginTop: '10px' }} icon={['fas', 'envelope']} />
								<input className="lg-in" type="username" onChange={event => this.setState({ username: event.target.value })} placeholder="email@yourdomain.com" />
							</div>
						</div>
						<div className="login-input-wrap">
							<label className="login-lb">รหัสผ่าน</label>
							<div className="login-input">
								<FontAwesomeIcon style={{ fontSize: "20px", color: "grey", marginTop: '10px' }} icon={['fas', 'lock']} />
								<input className="lg-in" type="password" onChange={event => this.setState({ password: event.target.value })} />
							</div>
						</div>
						<div className="login-caution">
							{this.state.caution}
						</div>
						<div className="login-button-wrap">
							<div className="login-page-button login-page-button-login" onClick={() => {
								if (this.state.username && this.state.password) {
									this.validate();
								}
							}}>
								เข้าสู่ระบบ
						</div>
							<div className="login-page-button">
								<a className=" login-page-button-register" href="https://www.borntodev.com/my-account/">
									ลงทะเบียนใหม่
								</a>
							</div>
						</div>
					</form>



					<a href="https://www.borntodev.com/my-account/lost-password/">
						ลืมรหัสผ่าน ?
					</a>
				</div>
				<div className="login-cover">

				</div>
			</div>
		)
	}

	validate() {

		this.setState({ validating: true });
		let self = this;
		let formData = new FormData();
		formData.append('type', 'login');
		formData.append('username', this.state.username);
		formData.append('password', this.state.password);

		return fetch('https://www.borntodev.com/wp-json/devblog/v1/login', {
			method: 'POST',
			body: formData
		})
			.then((response) => response.json())
			.then((responseJson) => {


				if (!responseJson.success) {



					this.setState({ caution: "รหัสผ่านผิดพลาด" })
					throw new Error('incorrect username or password.');
				} else {
					// console.log("login")
					// console.log(responseJson)
					let data = responseJson.data;

					this.updateToken(data)
					this.props.goHome()

				}


			})
			.catch((error) => {
				// console.error(error);
			});
	}

	updateToken(data) {

		// console.log(data)
		data["loggedIn"] = true
		localStorage.setItem("btd-bdt", JSON.stringify(data))
		this.context.setUserData(data);
		this.props.onCloseModal()

	}
}
